import React, { Children, useEffect, useState, useCallback } from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import imageComum from 'assets/antIcons/fileImage.svg';

import { Image } from 'components/UI/Image/Image';

import * as S from './DetailsImageGallery.styled';

export type IProps = {
  defaultImage: string;
  images: string[];
  productName: string;
  isLkpOffer: boolean;
  onImageClick?: (images: string[], title: string) => void;
};

export default function DetailsImageGallery(props: IProps) {
  const { defaultImage, images, productName, isLkpOffer, onImageClick } = props;

  const [arrayImage, setArrayImage] = useState<string[]>([
    defaultImage || imageComum,
  ]);
  const [imageDisplay, setImageDisplay] = useState<number>(0);

  useEffect(() => {
    if (images && images.length > 0) {
      setArrayImage(images);
    } else {
      setArrayImage([defaultImage || imageComum]);
    }
  }, [images, defaultImage]);

  const handleImageClick = useCallback(() => {
    const validImages = arrayImage.filter(img => img !== imageComum);
    if (validImages.length > 0 && onImageClick) {
      onImageClick(validImages, `Imagens da oferta: ${productName}`);
    }
  }, [arrayImage, productName, onImageClick]);

  return (
    <S.Gallery>
      <S.ImagesListBackground>
        <S.ImagesList>
          {Children.toArray(
            arrayImage?.map((image, index) => (
              <Image
                border="1px solid #D9D9D9"
                size={80}
                src={image}
                alt={`${productName} ${index}`}
                onClick={() => setImageDisplay(index)}
              />
            )),
          )}
        </S.ImagesList>
      </S.ImagesListBackground>
      <S.ImagesDisplay>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 8,
          }}
        >
          <img 
            src={arrayImage[imageDisplay]} 
            alt={productName}
            onClick={handleImageClick}
            style={{ cursor: 'pointer' }}
          />
          <S.ImageLabel>
            {`Imagem ${
              images?.length > 0 && !isLkpOffer ? 'do produtor' : 'ilustrativa'
            }`}
          </S.ImageLabel>
          <S.ImageNavigation>
            <button
              type="button"
              aria-label="Imagem anterior"
              onClick={() => setImageDisplay((prev) => Math.max(prev - 1, 0))}
              disabled={imageDisplay === 0}
            >
              <LeftOutlined />
            </button>
            <span className="image-numbers">
              {imageDisplay + 1} de {arrayImage.length}
            </span>
            <button
              type="button"
              aria-label="Próxima imagem"
              onClick={() =>
                setImageDisplay((prev) =>
                  Math.min(prev + 1, arrayImage.length - 1),
                )
              }
              disabled={imageDisplay === arrayImage.length - 1}
            >
              <RightOutlined />
            </button>
          </S.ImageNavigation>
        </div>
      </S.ImagesDisplay>
    </S.Gallery>
  );
}
